// extracted by mini-css-extract-plugin
export default {"TechInfo":"TechInfo_TechInfo__4BaQo","center":"TechInfo_center__FL2gM","cards":"TechInfo_cards__q6lkU"};